module.exports = __webpack_public_path__ + "img/5.69309b35.jpg";